/*
 * @Description: 首页请求类型定义
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2022-01-18 13:41:00
 * @LastEditTime: 2022-01-19 16:51:34
 * @LastEditors: 安知鱼
 */

import anRequest from '../index'

import { IDataType } from '../types'

enum HomeAPI {
  CarouselData = '/webstieBanner',
  Introduction = '/webstieCompany',
  Product = '/webstieServe',
  Partner = '/webstiePartner',
  Recruitment = '/websiteRecruitment',
  TitleBanner = '/webstieTitleUrl'
}

/**
 * @Description: 请求首页轮播图数据
 * @Author: 安知鱼
 * @param  {*}
 * @return {*}
 */
export function requestCarouselData() {
  return anRequest.get<IDataType>({
    url: HomeAPI.CarouselData
  })
}

/**
 * @Description: 请求首页企业简介数据
 * @Author: 安知鱼
 * @param  {*}
 * @return {*}
 */
export function requestIntroductionData() {
  return anRequest.get<IDataType>({
    url: HomeAPI.Introduction
  })
}

/**
 * @Description: 请求首页产品与服务数据
 * @Author: 安知鱼
 * @param  {*}
 * @return {*}
 */
export function requestProductResultData() {
  return anRequest.get<IDataType>({
    url: HomeAPI.Product
  })
}

/**
 * @Description: 请求首页合作伙伴与主要客户数据
 * @Author: 安知鱼
 * @param  {*}
 * @return {*}
 */
export function requestPartnerData() {
  return anRequest.get<IDataType>({
    url: HomeAPI.Partner,
    params: { pageNum: 1, pageSize: 100 }
  })
}

export function requestRecruitmentData() {
  return anRequest.get<IDataType>({
    url: HomeAPI.Recruitment
  })
}

export function requestTitleBanner(type: number) {
  return anRequest.get<IDataType>({
    url: `${HomeAPI.TitleBanner}/${type}`
  })
}
